import { type ComponentPropsWithoutRef, memo } from 'react';

import { CommandItem } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

export type ComboboxItemProps = ComponentPropsWithoutRef<typeof CommandItem>;

export const ComboboxItem = memo(({ children, className, ...restOfProps }: ComboboxItemProps) => {
  return (
    <CommandItem
      className={cn(
        'group/combobox-item flex min-h-[32px] cursor-pointer items-center gap-2 rounded-4 px-2 text-14 text-gray-12 outline-none hover:bg-gray-4 active:bg-gray-5 data-[selected=true]:bg-gray-4',
        className,
      )}
      data-testid="COMBOBOX_ITEM"
      {...restOfProps}
    >
      {children}
    </CommandItem>
  );
});

ComboboxItem.displayName = 'ComboboxItem';
